import {
  meta,
  shopify,
  starbucks,
  tesla,
  homyfy,
  freeio,
  grogin,
  medipro,
} from "../assets/images"
import {
  angular,
  bootstrap,
  car,
  contact,
  css,
  estate,
  express,
  git,
  github,
  html,
  javascript,
  linkedin,
  mongodb,
  motion,
  mui,
  nextjs,
  pricewise,
  react,
  redux,
  sass,
  snapgram,
  summiz,
  tailwindcss,
  threads,
  typescript,
  nodejs,
  vuejs,
  laravel,
  nest,
  mysql,
  django,
} from "../assets/icons"
import * as homyfyAssets from "../assets/demos/homyfy"
import * as onlineStoreAssets from "../assets/demos/online store"
import * as jobBoardAssets from "../assets/demos/job board"
import * as medicalAssets from "../assets/demos/medical"
import * as wpAssets from "../assets/demos/mute"

import type { Project } from "../lib/types"

export const skills = [
  {
    imageUrl: html,
    name: "HTML",
    type: "Frontend",
  },
  {
    imageUrl: css,
    name: "CSS",
    type: "Frontend",
  },
  {
    imageUrl: javascript,
    name: "JavaScript",
    type: "Frontend",
  },
  {
    imageUrl: typescript,
    name: "TypeScript",
    type: "Frontend",
  },

  {
    imageUrl: express,
    name: "Express",
    type: "Backend",
  },
  {
    imageUrl: nodejs,
    name: "Node",
    type: "Backend",
  },
  {
    imageUrl: laravel,
    name: "Laravel",
    type: "Backend",
  },
  {
    imageUrl: django,
    name: "Django",
    type: "Backend",
  },
  {
    imageUrl: mysql,
    name: "Mysql",
    type: "Backend",
  },
  {
    imageUrl: react,
    name: "React",
    type: "Frontend",
  },
  {
    imageUrl: redux,
    name: "Redux",
    type: "State Management",
  },
  {
    imageUrl: nextjs,
    name: "Next.js",
    type: "Frontend",
  },
  {
    imageUrl: git,
    name: "Git",
    type: "Version Control",
  },
  {
    imageUrl: github,
    name: "GitHub",
    type: "Version Control",
  },

  {
    imageUrl: mongodb,
    name: "MongoDB",
    type: "Database",
  },

  {
    imageUrl: motion,
    name: "Motion",
    type: "Animation",
  },

  {
    imageUrl: mui,
    name: "Material-UI",
    type: "Frontend",
  },

  /*
  {
    imageUrl: nodejs,
    name: "Node.js",
    type: "Backend",
  },
  */

  {
    imageUrl: sass,
    name: "Sass",
    type: "Frontend",
  },
  {
    imageUrl: tailwindcss,
    name: "Tailwind CSS",
    type: "Frontend",
  },

  {
    imageUrl: bootstrap,
    name: "Bootstrap",
    type: "Frontend",
  },
  {
    imageUrl: angular,
    name: "Angular",
    type: "Frontend",
  },
  {
    imageUrl: vuejs,
    name: "Vue js",
    type: "Frontend",
  },
]

export const experiences = [
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: starbucks,
    iconBg: "#accbe1",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React Native Developer",
    company_name: "Tesla",
    icon: tesla,
    iconBg: "#fbc3bc",
    date: "Jan 2021 - Feb 2022",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Web Developer",
    company_name: "Shopify",
    icon: shopify,
    iconBg: "#b7e4c7",
    date: "Jan 2022 - Jan 2023",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Full stack Developer",
    company_name: "Meta",
    icon: meta,
    iconBg: "#a2d2ff",
    date: "Jan 2023 - Present",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
]

export const socialLinks = [
  {
    name: "Contact",
    iconUrl: contact,
    link: "/contact",
  },
  {
    name: "GitHub",
    iconUrl: github,
    link: "https://github.com/YourGitHubUsername",
  },
  {
    name: "LinkedIn",
    iconUrl: linkedin,
    link: "https://www.linkedin.com/in/YourLinkedInUsername",
  },
]

export const projects: Project[] = [
  {
    id: "amazon-price-tracker",
    slug: "amazon-price-tracker",
    iconUrl: pricewise,
    theme: "btn-back-red",
    name: "Amazon Price Tracker",
    description:
      "Developed a web application that tracks and notifies users of price changes for products on Amazon, helping users find the best deals.",
    link: "https://github.com/adrianhajdin/pricewise",
    demoLink: "https://github.com/adrianhajdin/pricewise",
    cover: pricewise,
  },
  {
    id: "threads-clone",
    slug: "threads-clone",
    iconUrl: threads,
    theme: "btn-back-green",
    name: "Full Stack Threads Clone",
    description:
      'Created a full-stack replica of the popular discussion platform "Threads," enabling users to post and engage in threaded conversations.',
    link: "https://github.com/adrianhajdin/threads",
    cover: threads,
  },
  {
    id: "car-finding-app",
    slug: "car-finding-app",
    iconUrl: car,
    theme: "btn-back-blue",
    name: "Car Finding App",
    description:
      "Designed and built a mobile app for finding and comparing cars on the market, streamlining the car-buying process.",
    link: "https://github.com/adrianhajdin/project_next13_car_showcase",
    cover: car,
  },
  {
    id: "instagram-clone",
    slug: "instagram-clone",
    iconUrl: snapgram,
    theme: "btn-back-pink",
    name: "Full Stack Instagram Clone",
    description:
      "Built a complete clone of Instagram, allowing users to share photos and connect with friends in a familiar social media environment.",
    link: "https://github.com/adrianhajdin/social_media_app",
    cover: snapgram,
  },
  {
    id: "real-estate-app",
    slug: "real-estate-app",
    iconUrl: estate,
    theme: "btn-back-black",
    name: "Real-Estate Application",
    description:
      "Developed a web application for real estate listings, facilitating property searches and connecting buyers with sellers.",
    link: "https://github.com/adrianhajdin/projects_realestate",
    cover: estate,
  },
  {
    id: "ai-summarizer",
    slug: "ai-summarizer",
    iconUrl: summiz,
    theme: "btn-back-yellow",
    name: "AI Summarizer Application",
    description:
      "App that leverages AI to automatically generate concise & informative summaries from lengthy text content, or blogs.",
    link: "https://github.com/adrianhajdin/project_ai_summarizer",
    cover: summiz,
  },
]
export const realProject: Project[] = [
  {
    id: "homyfy-laravel-nextjs",
    slug: "homyfy-laravel-nextjs",
    name: "Homyfy - laravel and next.js",
    description: "A property finder platform designed for university student",
    projectType: "Full Stack",
    skills: ["Laravel", "Next.js", "MySQL", "Tailwind CSS", "React"],
    cover: homyfy,
    link: "https://github.com/mashady/laravel_final_project",
    demoLink: "https://vimeo.com/1103847883",
    assets: [
      { type: "image", url: homyfyAssets.homepagefullscreen },
      { type: "image", url: homyfyAssets.h1 },
      { type: "image", url: homyfyAssets.h2 },
      { type: "image", url: homyfyAssets.h3 },
      { type: "image", url: homyfyAssets.h4 },
      { type: "image", url: homyfyAssets.h5 },
      { type: "image", url: homyfyAssets.h6 },
      { type: "image", url: homyfyAssets.h7 },
      { type: "image", url: homyfyAssets.h8 },
      { type: "image", url: homyfyAssets.h9 },
      { type: "image", url: homyfyAssets.h10 },
      { type: "image", url: homyfyAssets.h11 },
      { type: "image", url: homyfyAssets.h12 },
      { type: "image", url: homyfyAssets.h13 },
      { type: "image", url: homyfyAssets.h14 },
      { type: "image", url: homyfyAssets.h15 },
      { type: "image", url: homyfyAssets.h16 },
      { type: "image", url: homyfyAssets.h17 },
      { type: "image", url: homyfyAssets.h18 },
      { type: "image", url: homyfyAssets.h19 },
      { type: "image", url: homyfyAssets.h20 },
      { type: "image", url: homyfyAssets.h21 },
      { type: "image", url: homyfyAssets.h22 },
      { type: "image", url: homyfyAssets.h23 },
      { type: "image", url: homyfyAssets.h24 },
      { type: "image", url: homyfyAssets.h25 },
      { type: "video", url: "https://vimeo.com/1103847883" }
    ]
  },
  {
    id: "ecommerce-nodejs-angular",
    slug: "ecommerce-nodejs-angular",
    name: "E-Commerce Platform - nodejs and angular",
    description:
      "A full-featured e-commerce platform built with Angular and Node.js, integrated with Stripe for payments. Users can browse products, add them to the cart, and pay online. Includes an admin dashboard for managing orders and inventory.",
    projectType: "Full Stack",
    skills: ["Node.js", "Angular", "Express", "MongoDB", "Stripe"],
    cover: grogin,
    link: "https://github.com/mashady/node-js-ecommerce",
    demoLink: "https://vimeo.com/1103854867",
    assets: [
      { type: "image", url: onlineStoreAssets.oneShot },
      { type: "image", url: onlineStoreAssets.header },
      { type: "image", url: onlineStoreAssets.s1 },
      { type: "image", url: onlineStoreAssets.s2 },
      { type: "image", url: onlineStoreAssets.s3 },
      { type: "image", url: onlineStoreAssets.s4 },
      { type: "image", url: onlineStoreAssets.s5 },
      { type: "image", url: onlineStoreAssets.s6 },
      { type: "image", url: onlineStoreAssets.s7 },
      { type: "image", url: onlineStoreAssets.s8 },
      { type: "image", url: onlineStoreAssets.s9 },
      { type: "video", url: "https://vimeo.com/1103854867" }
    ]
  },
  {
    id: "job-board-laravel-vuejs",
    slug: "job-board-laravel-vuejs",
    name: "Job board - full stack laravel and vuejs",
    description:
      "A platform connecting freelancers with clients. Users can register as either freelancers or employers, post jobs or projects, and apply. Includes dashboards tailored for each user role.",
    projectType: "Full Stack",
    skills: ["Laravel", "Vue.js", "PostgreSQL", "Vuex", "Tailwind CSS"],
    cover: freeio,
    link: "https://github.com/mashady/jobs_and_freelancing_platform_backend",
    demoLink: "https://vimeo.com/1103854162",
    assets: [
      { type: "image", url: jobBoardAssets.header },
      { type: "image", url: jobBoardAssets.fullScreen },
      { type: "image", url: jobBoardAssets.s1 },
      { type: "image", url: jobBoardAssets.s2 },
      { type: "image", url: jobBoardAssets.s3 },
      { type: "image", url: jobBoardAssets.s4 },
      { type: "image", url: jobBoardAssets.s5 },
      { type: "image", url: jobBoardAssets.s6 },
      { type: "image", url: jobBoardAssets.s7 },
      { type: "image", url: jobBoardAssets.s8 },
      { type: "image", url: jobBoardAssets.s9 },
      { type: "image", url: jobBoardAssets.s10 },
      { type: "image", url: jobBoardAssets.s11 },
      { type: "image", url: jobBoardAssets.s12 },
      { type: "image", url: jobBoardAssets.s13 },
      { type: "image", url: jobBoardAssets.s14 },
      { type: "image", url: jobBoardAssets.s15 },
      { type: "video", url: "https://vimeo.com/1103854162" }
    ]
  },
  {
    id: "medical-django-react",
    slug: "medical-django-react",
    name: "medical - full stack django and react",
    description:
      "A web-based hospital management system for handling patients, appointments, doctors, and medical records. Supports multi-role authentication (admin, doctor, patient).",
    projectType: "Full Stack",
    skills: ["Django", "React", "Python", "SQLite", "Redux"],
    cover: medipro,
    link: "https://youtu.be/lCoQxygGI7c",
    demoLink: "https://vimeo.com/1103853679",
    assets: [
      { type: "image", url: medicalAssets.fullPage },
      { type: "image", url: medicalAssets.doctorCapture },
      { type: "image", url: medicalAssets.s1 },
      { type: "image", url: medicalAssets.s2 },
      { type: "image", url: medicalAssets.s3 },
      { type: "image", url: medicalAssets.s4 },
      { type: "image", url: medicalAssets.s5 },
      { type: "image", url: medicalAssets.s6 },
      { type: "image", url: medicalAssets.s7 },
      { type: "image", url: medicalAssets.s8 },
      { type: "image", url: medicalAssets.s9 },
      { type: "image", url: medicalAssets.s10 },
      { type: "image", url: medicalAssets.s11 },
      { type: "image", url: medicalAssets.s12 },
      { type: "image", url: medicalAssets.s13 },
      { type: "video", url: "https://vimeo.com/1103853679" }
    ]
  },
  {
    id: "wordpress-store",
    slug: "wordpress-store",
    name: "WordPress E-Commerce Store",
    description: "A professional e-commerce store built with WordPress, featuring a clean design and seamless user experience.",
    projectType: "Full Stack",
    skills: ["WordPress", "WooCommerce", "PHP", "CSS", "Elementor"],
    cover: wpAssets.wp,
    link: "",
    demoLink: "https://sound-mute.ar/",
    assets: [
      { type: "image", url: wpAssets.fullPage },
      { type: "image", url: wpAssets.wp },
      { type: "image", url: wpAssets.contactPage },
      { type: "image", url: wpAssets.s1 },
      { type: "image", url: wpAssets.s2 },
      { type: "image", url: wpAssets.s3 },
      { type: "image", url: wpAssets.s4 },
      { type: "image", url: wpAssets.s5 },
      { type: "image", url: wpAssets.s6 },
      { type: "image", url: wpAssets.s7 }
    ]
  },
  {
    id: "react-store",
    slug: "react-store",
    name: "React store",
    description:
      "Online store and e commerce app designed to provide user with a seamless user experience while offering a range of products",
    projectType: "Frontend",
    skills: ["React", "Context API", "CSS Modules", "Netlify"],
    cover:
      "https://raw.githubusercontent.com/mashady/store-by-react/main/promo/store-with-react-header.png",
    link: "https://github.com/mashady/store-by-react",
    demoLink: "https://react-store-by-abu.netlify.app/",
    assets: [
      { type: "image", url: "https://raw.githubusercontent.com/mashady/store-by-react/main/promo/store-with-react-header.png" }
    ]
  },
  {
    id: "movie-hub",
    slug: "movie-hub",
    name: "movie hub ",
    description:
      "Users can search for movies by title, browse through diƦerent genres, and discover trending or popular films.",
    projectType: "Frontend",
    skills: ["React", "TMDB API", "Axios", "Vercel"],
    cover:
      "https://raw.githubusercontent.com/mashady/moviehubWeb/main/promotion/appHeaderMovieHub.png",
    link: "https://github.com/mashady/moviehubWeb",
    demoLink: "https://moviehub-web-iota.vercel.app/",
    assets: [
      { type: "image", url: "https://raw.githubusercontent.com/mashady/moviehubWeb/main/promotion/appHeaderMovieHub.png" }
    ]
  },
  {
    id: "issue-tracker",
    slug: "issue-tracker",
    name: "issue tracker",
    description: "Full stack NextJS app - Issue tracker admin dashboard.",
    projectType: "Full Stack",
    skills: ["Next.js", "Prisma", "Radix UI", "Zod", "NextAuth.js"],
    cover:
      "https://raw.githubusercontent.com/mashady/issue-tracker-by-abu/main/promo/issues-tracker-promo.png",
    link: "https://github.com/mashady/issue-tracker-by-abu",
    demoLink: "https://youtu.be/uV6kO645-Xk",
    assets: [
      { type: "image", url: "https://raw.githubusercontent.com/mashady/issue-tracker-by-abu/main/promo/issues-tracker-promo.png" },
      { type: "video", url: "https://youtu.be/uV6kO645-Xk" }
    ]
  },
  {
    id: "dashboard-react",
    slug: "dashboard-react",
    name: "dashboard with react",
    description:
      "React Simple Admin Dashboard App provides a clean and intuitive interface for managing various aspects of an application or website. Built using React, it oƦers easy customization and scalability.",
    projectType: "Frontend",
    skills: ["React", "Material UI", "Recharts", "Formik"],
    cover:
      "https://raw.githubusercontent.com/mashady/dashboard-with-react/main/promo/appHeader4dashboardproject.png",
    link: "https://github.com/mashady/dashboard-with-react",
    demoLink: "https://admin-dashboard-by-mashady.netlify.app/",
    assets: [
      { type: "image", url: "https://raw.githubusercontent.com/mashady/dashboard-with-react/main/promo/appHeader4dashboardproject.png" }
    ]
  },
]
